// extracted by mini-css-extract-plugin
export default {"container":"RecommendationCenter_container__XEiVT","scrollableContent":"RecommendationCenter_scrollableContent__CI5Lb"};